module.exports = __webpack_public_path__ + "img/CanceledE.3be2d7fb.png";